import { zodResolver } from '@hookform/resolvers/zod'
import { Stack } from '@mui/joy'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { stringRequiredScheme } from '~/shared/lib/schemas'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider, TextareaInput } from '~/shared/ui/Form'

const formSchema = z.object({
  comment: stringRequiredScheme,
})

type FormValues = {
  comment: string
}

type FormProps = {
  onCancel: () => void
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ onCancel, onSuccess, isSubmitting }: FormProps) {
  const { t } = useTranslation()
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <TextareaInput
        label='form.comment'
        name='comment'
        placeholder='form.enter comment'
        readOnly={isSubmitting}
        sx={{
          height: '138px',
        }}
      />
      <br />
      <Stack direction='row' justifyContent='space-between' spacing={2}>
        <Button
          variant='gray'
          onClick={onCancel}
          disabled={isSubmitting}
          fullWidth
        >
          {t('button.cancel')}
        </Button>
        <Button variant='red' type='submit' loading={isSubmitting} fullWidth>
          {t('button.reject')}
        </Button>
      </Stack>
    </FormProvider>
  )
}
